// extracted by css-extract-rspack-plugin
export default {"handle_btn":"handle_btn___+Ikjs","hover":"hover___RkdeM"};